export const LOCK_KEY = 'silentAuthRedirectLockUntil';
export const LOCK_MS = 30_000;

export const getLockUntil = () => Number(sessionStorage.getItem(LOCK_KEY) || 0);
export const setLockFor = (ms = LOCK_MS) =>
  sessionStorage.setItem(LOCK_KEY, String(Date.now() + ms));
export const canRedirect = () => Date.now() >= getLockUntil();
export const isOnSilentLogin = () =>
  window.location.pathname.startsWith('/auth/silent-login');
